import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useSubIbStatusTagTranslations = () => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      pendingLabel: t("subIBReport_ibStatusPending", "Pending"),
      pendingMessage: t(
        "subIBReport_ibStatusPendingTooltip",
        "This Sub IB isn’t an approved IB yet. You can all refer clients and earn now. Your Sub IB just can't withdraw until approved.",
      ),
      gotItLabel: t("web_subibreport_pendingsheet_btn_got_it", "Got it"),
      rejectedLabel: t("subIBReport_ibStatusRejected", "Rejected"),
      rejectedMessage: t(
        "subIBReport_ibStatusRejectedTooltip",
        "This Sub IB's profile has not been approved. Their share of the rebate is paid to you until they are approved. If they reapply and are approved, the original split resumes.",
      ),
    }),
    [t],
  );
};
